import { render, staticRenderFns } from "./PickUpTimeUpdate.vue?vue&type=template&id=636184a6&scoped=true&"
import script from "./PickUpTimeUpdate.vue?vue&type=script&lang=js&"
export * from "./PickUpTimeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PickUpTimeUpdate.vue?vue&type=style&index=0&id=636184a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636184a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
